export const locale = {
    lang: 'vn',
    data: {
        APP_SWITCHER_DIALOG: {
            SWITCH_MODULE: 'Chuyển đổi module',
            CLOSE: 'ĐÓNG'
        }
    }
};
